export const MessageType = {
    Navigation: 'NAVIGATION',
    Initial: 'INITIAL',
    HeightChanged: 'HEIGHT_CHANGED',
    PopoverUpdate: 'POPOVER_UPDATE',
    LayoutUpdate: 'LAYOUT_UPDATE',
    Click: 'CLICK',
    OverlayOpened: 'OVERLAY_OPENED',
    OverlayClosed: 'OVERLAY_CLOSED',
    SessionStart: 'SESSION_START',
    SessionEnd: 'SESSION_END',
    SessionRefresh: 'SESSION_REFRESH',
} as const;

export type MessageTypeValue = (typeof MessageType)[keyof typeof MessageType];
